(() => {
  const readyAttribute = 'data-ra-ready';

  function initPageScrollState() {
    if (document.documentElement.hasAttribute('data-ra-scroll-ready')) return;
    document.documentElement.setAttribute('data-ra-scroll-ready', 'true');

    let scheduled = false;
    const update = () => {
      document.body.classList.toggle('ra-page-scrolled', window.scrollY > 48);
      scheduled = false;
    };
    window.addEventListener('scroll', () => {
      if (!scheduled) {
        scheduled = true;
        window.requestAnimationFrame(update);
      }
    }, { passive: true });
    update();
  }

  function initMobileHeaderSearch() {
    const details = document.querySelector('.header.header--top-left > details-modal.header__search > details');
    if (!details || details.hasAttribute('data-ra-search-ready')) return;
    details.setAttribute('data-ra-search-ready', 'true');

    const mobile = window.matchMedia('(max-width: 767px)');
    const applyMode = () => {
      if (mobile.matches) {
        details.removeAttribute('open');
      } else {
        details.setAttribute('open', '');
      }
    };

    mobile.addEventListener?.('change', applyMode);
    applyMode();
  }

  function initMobileBuyBar(bar) {
    if (bar.hasAttribute(readyAttribute)) return;
    const sectionId = bar.dataset.sectionId;
    const original = document.getElementById(`ProductSubmitButton-${sectionId}`);
    const proxy = bar.querySelector('[data-ra-mobile-buy-button]');
    if (!original || !proxy) return;

    bar.setAttribute(readyAttribute, 'true');

    const sync = () => {
      proxy.disabled = original.disabled;
      const label = original.querySelector('span span') || original.querySelector('span');
      proxy.textContent = label?.textContent?.trim() || 'Add to cart';
    };

    const setVisible = (visible) => {
      const show = visible && window.matchMedia('(max-width: 767px)').matches;
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('ra-buy-bar-visible', show);
    };

    const observer = new IntersectionObserver(([entry]) => setVisible(!entry.isIntersecting), {
      rootMargin: '0px 0px -12% 0px',
      threshold: 0.05,
    });
    observer.observe(original);

    const stateObserver = new MutationObserver(sync);
    stateObserver.observe(original, { attributes: true, childList: true, subtree: true });

    proxy.addEventListener('click', () => {
      sync();
      if (!proxy.disabled) original.click();
    });

    window.addEventListener('resize', () => {
      if (!window.matchMedia('(max-width: 767px)').matches) setVisible(false);
    }, { passive: true });
    sync();
  }

  function init(root = document) {
    initPageScrollState();
    initMobileHeaderSearch();
    root.querySelectorAll('[data-ra-mobile-buy]').forEach(initMobileBuyBar);
  }

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));

  const reconnectObserver = new MutationObserver((mutations) => {
    if (mutations.some((mutation) => mutation.addedNodes.length)) init();
  });
  reconnectObserver.observe(document.documentElement, { childList: true, subtree: true });
})();
